module.exports = __webpack_public_path__ + "img/slider4.403a3a0b.jpg";